export const Roles = { admin: 'A', coordinador: 'C', tecnico: 'T', empleado: 'E' };

// export function ValidarAmostrar( roles, rolUser ) {
//   console.log('Hola')
//   const userRoles = JSON.parse('["'+rolUser+'"]');
//   const allowedRoles = roles;
//   const matchingRoles = userRoles.filter(x => allowedRoles.includes(x));
//   // console.log(rolUser)
//   // console.log(roles)
//   // console.log( (matchingRoles.length > 0) ? false : true )
//   return (matchingRoles.length > 0) ? false : true;
// }